import React, { Component } from "react";
import * as api from '../../../../api';
import { Grid, Modal, Button, Input, Dropdown, Checkbox, Form, Popup } from 'semantic-ui-react';
import UserTabs from './user-tabs'
import { toast } from 'react-toastify';
import '../manage-users.scss'

class EditUserModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isFundLevel : this.props.data.isFundLevel,
            isReadOnly : this.props.data.isReadOnly,
            roleId : this.props.data.roleId
        };

    }

    onCheckboxChangeLocal = (event, { name, checked }) => {


        this.setState({ [name]: checked })

        this.props.onCheckboxChange(null,{ name, checked })
    }

    handleUserRoleLocal = (event, { name, value }) => {

        this.setState( {roleId : value} )


        
        api.removeUserSubRoles(this.props.data.id, "FEF0AABB-CD79-47AF-9195-DF43EA3C802F") //Dirty this.ToDo
        .then((data) => {
            api.removeUserSubRoles(this.props.data.id, "8C9BB5E1-8D20-4F5B-8376-A69980D58A1A")
            .then((data) => {
                api.addUserSubRoles(this.props.data.id, value)
        .then((data) => {
        })
        .catch((error) => {
          console.log(error)
        })
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch((error) => {
          console.log(error)
        })

      

        

        toast.success("Role updated", {
            position: toast.POSITION.TOP_CENTER,
            delay: 500
        });

        this.props.handleUserRole(null,  { name, value })
    }

    resetPassword = () => {
        api.resetUserPassword(this.props.data.id)
            .then((data) => {
                if (data.status === "Success") { this.notify() }

            })
            .catch((error) => {
                console.log(error)
            })

    }
    notify = () => {
        toast.success("Your password change request has been sent Successfully !", {
            position: toast.POSITION.TOP_CENTER,
            delay: 500
        });
    }
    render() {


        const roles = this.props.rolesList.filter((item) => {
            return (item.roleName === "Client User All" || item.roleName === "Client User")

        })


        

        const options = []
        for (let i = 0; i < roles.length; i++) {
            if (roles[i].roleName === "Client User All") { options.push({ key: roles[i].roleId, text: "Access to whole client Portfolio", value: roles[i].roleId }); }
            if (roles[i].roleName === "Client User") { options.push({ key: roles[i].roleId, text: "Access to only my sites", value: roles[i].roleId }); }
        }
        return <>

            <Modal size="large"

                trigger={<Popup
                    trigger={<Button circular color='facebook' className="custom-mrg2" icon='pencil alternate' onClick={() => this.props.handleEditUser(this.props.data)} />}
                    position="top center"
                >
                    Edit
                </Popup>}
                onOpen={this.props.setModalOpen}
                onClose={this.props.setModalClose}
                open={this.props.open}
            >
                <Modal.Header className="header-head">Edit User<Button compact floated='right' color='facebook' onClick={this.resetPassword} >Reset Password</Button></Modal.Header>
                <Modal.Content >
                    <Form>
                        <Grid padded stackable columns='equal'>
                            <Grid.Row>
                                <Grid.Column Border BorderBrush="Black" BorderThickness="2">First Name
                                    <Input
                                        type="text"
                                        fluid
                                        placeholder='Please enter a First name'
                                        name="firstName"
                                        className="edit-user-input"
                                        defaultValue={this.props.data.firstName}
                                        onChange={this.props.onInputChange}

                                    />
                                </Grid.Column>

                                <Grid.Column>Last Name
                                    <Input
                                        className="edit-user-input"
                                        type="text"
                                        placeholder='Please enter a Last Name'
                                        fluid
                                        name="surname"
                                        defaultValue={this.props.data.surname}
                                        onChange={this.props.onInputChange}

                                    />
                                </Grid.Column>
                                <Grid.Column>E-mail Address
                                    <Input
                                        className="edit-user-input"
                                        type="text"
                                        fluid
                                        placeholder='Please enter an e-mail address'
                                        name="userId"
                                        defaultValue={this.props.data.username}
                                        onChange={this.props.onInputChange}

                                    />
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Row>
                                <Grid.Column>Role
                                    <Dropdown
                                        className="edit-user-list"
                                        fluid
                                        selection
                                        options={options}
                                        placeholder='Please select a role'
                                        name="role"
                                        onChange={(event, data) => { this.props.onInputChange(event, data); this.handleUserRoleLocal(event, data) }}
                                        defaultValue={this.props.data.roleId}
                                    />
                                </Grid.Column>
                                <Grid.Column></Grid.Column>
                                <Grid.Column></Grid.Column>
                            </Grid.Row>

                            <Grid.Row>
                                <Grid.Column>
                                    <Checkbox
                                        defaultChecked={this.props.data.isReadOnly}
                                        className="edit-user-label"
                                        label='Read Only'
                                        name="isReadOnly"
                                        onChange={this.onCheckboxChangeLocal}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                    <Checkbox
                                        defaultChecked={this.props.data.dashboardUser}
                                        className="edit-user-label"
                                        label='Dashboard Access'
                                        name="DashboardUser"
                                        onChange={this.onCheckboxChangeLocal}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                    <Checkbox
                                        defaultChecked={this.props.data.isFundLevel}
                                        className="edit-user-label"
                                        label='Fund Level Access'
                                        name="isFundLevel"
                                        onChange={this.onCheckboxChangeLocal}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                    <Grid padded >
                        <Grid.Row>
                            <Grid.Column>
                                <UserTabs customerId={this.props.contextData.customerId} id={this.props.data.id} toggledTab={this.props.toggledTab} isFundLevel={this.state.isFundLevel} isReadOnly={this.state.isReadOnly}/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        basic color='red'
                        className="confirm-red-btn"
                        compact
                        onClick={this.props.setModalClose}
                    >Cancel</Button>
                    <Button
                        compact
                        className="confirm-bt-btn"
                        id='confirm-user'
                        onClick={this.props.handleUserSubmit}
                    >Save</Button>
                </Modal.Actions>
            </Modal>

        </>

    }
}
export default EditUserModal;
